import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    titles: [],
    subtitles: []
};

const titleSlice = createSlice({
    name: "title",
    initialState,
    reducers: {
        setTitles: (state, action) => {
            state.titles = action.payload.titles;
        },
        setSubtitles: (state, action) => {
            state.subtitles = action.payload.subtitles;
        },
    }
});

export const { setTitles, setSubtitles } = titleSlice.actions;

export const selectTitleState = (state) => state.title;

export default titleSlice.reducer;